module.exports = __webpack_public_path__ + "media/images/invoca/signal_glyph_sm-93c5c352d66c7e169f5c82ccd5feeebe.png";